// extracted by mini-css-extract-plugin
module.exports = {"bannerWrapper":"Home_bannerWrapper__Y2P_6","bannerInfo":"Home_bannerInfo__sXl_H","vhWrapper":"Home_vhWrapper__GxRZd","bannerCaptions":"Home_bannerCaptions__04NMK"};